import { useLayoutEffect, type RefObject } from 'react';

// Grow a textarea to fit its content so no inner scrollbar ever appears.
// Re-measures whenever `value` changes (and on mount / when re-shown).
export function useAutoGrow(ref: RefObject<HTMLTextAreaElement | null>, value: string): void {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }, [ref, value]);
}
